import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription, lastValueFrom } from 'rxjs';
import { FastAPIService } from 'src/app/service/fast-api.service';

@Component({
  selector: 'app-social-media-page',
  templateUrl: './social-media-page.component.html',
  styleUrls: ['./social-media-page.component.scss']
})
export class SocialMediaPageComponent {

  routerSubscribe: Subscription;
  constructor(private route: ActivatedRoute, private router: Router, private fastService: FastAPIService){
    this.routerSubscribe = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.url.split(';')[0] == '/social-media') {
        this.reload();
      }
    });
  }

  ngOnDestroy(): void {
    this.routerSubscribe?.unsubscribe();
  }

  loading: boolean = true;
  id: string | null = "";
  post: any;
  topic: string = "";
  detail: string = "";
  images: string = "";
  source: string = "";
  writer: string = "";
  comments: any[] = [];

  Score: string = 'Positive';
  Comment_Count: number = 20;
  Reaction_Count: number = 50;
  Engagement: number = 50;
  topWords: string[] = [];

  async reload() {
    this.loading = true;
    this.id = this.route.snapshot.paramMap.get('id');
    
    if (this.id) {
      const response = await lastValueFrom(this.fastService.saveHistory(this.id, 0));
      this.post = await this.fastService.searchWithLink(this.id);
      // console.log(this.post)
      if (this.id.includes('x.com')){
        this.source = this.post.Link_OD
        this.writer = this.post.PostData.Poster
        if(this.post.PostData.PostMedia.length > 0){
          this.images = this.post.PostData.PostMedia[0].url;
          this.fastService.checkURL(this.images).subscribe((response: any) => {}, httpErrorResponse => {
            if(httpErrorResponse.error == "URL signature expired") {
              this.images = this.post.Picture_URL_OD;
            }
          })
        } else {
          this.images = this.post.Picture_URL_OD;
        }
      } else {
        this.source = this.post.PostData.PostMedia.Media_URL;
        this.writer = 'Admin'
        this.images = this.post.PostData.PostMedia.Cover_Img;
        // console.log(this.images)
        this.fastService.checkURL(this.images).subscribe((response: any) => {}, httpErrorResponse => {
          if(httpErrorResponse.error == "URL signature expired") {
            this.images = this.post.Picture_URL_OD;
          }
        })
      }
      this.topic = this.post.Topic_OD;
      this.detail = this.post.Detail_OD;
      this.comments = this.post.PostData.PostComment;
      
      
      
      this.loading = false;
    }
  }


  //updateข้อมูล
  private updatePostAnalysis(analysis: any) {
    this.Score = this.getSentimentString(analysis.Score);
    this.Comment_Count = analysis.Comment_Count;
    this.Reaction_Count = analysis.Reaction_Count;
    this.Engagement = analysis.Engagement;
    this.topWords = analysis.TopWord;
  }

  //แปลงค่า Score เป็นข้อความ
  private getSentimentString(score: number): string {
    if (score === -1) return 'Negative';
    if (score === 0) return 'Neutral';
    if (score === 1) return 'Positive';
    return 'Unknown';
  }
  getSentimentImageSrc(): string {
    switch(this.Score) {
      case 'Positive': return 'assets/social-media-component-images/sentiment-analysis-Positive.png';
      case 'Neutral': return 'assets/social-media-component-images/sentiment-analysis-Neutral.png';
      case 'Negative': return 'assets/social-media-component-images/sentiment-analysis-Negative.png';
      default: return 'assets/social-media-component-images/sentiment-analysis-Neutral.png';
    }
  }
}
